import { GameVars } from "./GameVars";
import { FoundationPile } from "./states/cards/FoundationPile";
import { Board } from "./states/cards/Board";

export class AchievementsManager {

    private static _instance: AchievementsManager = null;  
    private suitCompleted: boolean;
    
    public static getInstance(): AchievementsManager {

        if (AchievementsManager._instance === null) {
            AchievementsManager._instance = new AchievementsManager();
        }

        return AchievementsManager._instance;
    }

    constructor() {

        if (AchievementsManager._instance) {
            throw new Error("Error: Instantiation failed: Use AchievementsManager.getInstance() instead of new.");
        }
        
        this.suitCompleted = false;
        AchievementsManager._instance = this;
    }

    public onGameWon(): void {
        
        if (!lechuck) {
            return;
        }
        
        lechuck.stat.put(function(response: any): any{
            console.log(response);
        }, "solitaire_completed", 1);
            
        const time = 1200 - GameVars.getInstance().time;
        
        lechuck.stat.put(function(response: any): any {
                console.log(response);
            }, "minutes", time);
        
        if (GameVars.getInstance().hints === 3) {
            lechuck.stat.put(function(response: any): any {
                console.log(response);
            }, "no_hints", 1);
        }
        
        if (GameVars.getInstance().reshuffles === 3) {
            lechuck.stat.put(function(response: any): any {
                console.log(response);
            }, "no_reshuffles", 1);
        }     
    }
    
    public onPileCovered(): void {
        
        if (this.suitCompleted) {
            return;
        }
        
        var foundationPiles: FoundationPile[] = Board.currentInstance.foundationPiles;
        
        if ((foundationPiles[0].covered && foundationPiles[4].covered)  ||
            (foundationPiles[1].covered && foundationPiles[5].covered)  ||
            (foundationPiles[2].covered && foundationPiles[6].covered)  ||
            (foundationPiles[3].covered && foundationPiles[7].covered)) {
                
            this.suitCompleted = true;
            
                lechuck.stat.put(function(response: any): any {
                console.log(response);
            }, "complete_suit", 1);
        }
    }
}

